<template>
  <FHButton
  class="c-feedback__wrapper"
    @mouseover.native="isUnfolded = true"
    @mouseleave.native="isUnfolded = false"
    @click.native="$emit('open-feedback')">
    <span
      class="c-feedback__msg"
      :class="isUnfolded ? 'c-feedback__msg--unfolded' : ''">
      {{ $t('FEEDBACK_TITLE')}}
    </span>
    <FeedbackIcon stroke="#FFF" />
  </FHButton>
</template>

<script>
import FHButton from '@forlagshuset/v-button'
import FeedbackIcon from '@/assets/svg/FeedbackIcon'

export default {
  components: {
    FHButton,
    FeedbackIcon
  },

  data () {
    return {
      isUnfolded: false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-feedback__wrapper {
  @include btnReset();
  position: fixed;
  bottom: 2em;
  right: 2em;
  border-radius: 2em;
  color: $white;
  background: $blue;
  display: flex;
  cursor: pointer;
}
.c-feedback__msg {
  line-height: 3em;
  visibility: hidden;
  width: 0;
  height: 0;
  &.c-feedback__msg--unfolded {
    visibility: visible;
    width: auto;
    height: 1em;
    padding-left: 1.5em;
    transition: all .5s;
  }
}
</style>